<template>
	<div>
		<h1>Nutze skilldoo 100% kostenfrei und anonym.</h1>
		<ul class="feature-list feature-list--tighter mb-5">
			<li v-for="(feature, i) in features" :key="'feature' + i">
				<Icon icon="checkmark" />
				<span class="text" v-html="feature"/>
			</li>
		</ul>
		<div class="tag-sections">
			<section class="tag">
				<b-row>
					<b-col md="5">
						<b-form-group :state="firstNameValid">
							<b-input v-model="personalData.firstName" placeholder="Mein Vorname" @input="emitChangeEvent"/>
						</b-form-group>
						<b-form-group
							:state="emailValid"
							:invalid-feedback="emailError && emailError.show ? emailError.message : undefined"
						>
							<b-input type="email" v-model="personalData.email" placeholder="Meine E-Mail-Adresse" @input="emitChangeEvent"/>
						</b-form-group>
					</b-col>
				</b-row>
				<b-row>
					<b-col md="10">
							<Password v-model="password" @input="emitChangeEvent"/>
					</b-col>
				</b-row>
			</section>
			<section class="tag">
				<PrivacyCheckbox v-model="privacy" agb-short @input="emitChangeEvent"/>
			</section>
		</div>
	</div>
</template>

<script>
import {isDefined} from "@/helper/Value";
import {isEmptyOrNull} from "@/helper/String";
import * as EmailValidator from 'email-validator';
import Password from "@/vue/common/form/Password";
import Icon from "@/vue/icon/Icon.vue";
import PrivacyCheckbox from "@/vue/common/PrivacyCheckbox.vue";

const FEATURES = [
	'Alle Services sind für Jobsuchende <span>kostenfrei</span>. Ausschließlich Arbeitgeber bezahlen für die Nutzung.',
	'<span>Anonym und sicher:</span> persönlichen Daten (Name, Adresse, E-Mail-Adresse, ...) erhält ein einzelner Arbeitgeber nur, wenn du sie ihm mitteilst. Unser Server befinden sich in Österreich und Deutschland. Du kannst deine Daten jederzeit ergänzen oder löschen.',
];

export default {

	components: {
		PrivacyCheckbox,
		Icon,
		Password,
	},

	props: {
		value: {
			type: Object,
			required: false,
		},
		title: {
			type: String,
			required: true,
		},
	},

	data ()
	{
		return {
			personalData: {
				firstName: this.value?.personalData.firstName || '',
				email: this.value?.personalData.email || '',
			},
			password: undefined,
			privacy: false,
		};
	},

	computed: {
		features ()
		{
			return FEATURES;
		},
		firstNameValid ()
		{
			return !isEmptyOrNull(this.personalData.firstName);
		},
		emailValid ()
		{
			return !isDefined(this.emailError);
		},
		emailError ()
		{
			if (!EmailValidator.validate(this.personalData.email))
			{
				return {
					show: !isEmptyOrNull(this.personalData.email),
					message: 'E-Mail Adresse unvollständig/ungültig'
				};
			}

			return null;
		},
		personalDataValid ()
		{
			return this.firstNameValid
				&& this.emailValid;
		},
		passwordValid ()
		{
			return isDefined(this.password);
		},
		valid ()
		{
			return this.personalDataValid
				&& this.passwordValid
				&& this.privacy;
		},
	},

	methods: {
		emitChangeEvent ()
		{
			this.$emit('input', {
				personalData: this.personalData,
				password: this.password,
				valid: this.valid,
			});
		},
	}
}
</script>
